const translations = {
    connect: 'Connect',
    disconnect: 'Disconnect',
    eaVisionDescription: 'This connection allows you to sync flights from EAVision.',
    eaVisionTitle: 'EAVision™',
    flightsLastSynced: 'EAVision flights last synced',
    syncNow: 'Sync Now'
};

export default translations;
